<template>


    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="28" height="24"
             viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
        <g>
            <path class="st0" d="M29.9,0.6c-0.1-0.2-0.3-0.4-0.5-0.5C29.3,0,29.1,0,29,0h-5.9c-0.5,0-1,0.4-1,1c0,0.6,0.4,1,1,1h3.5L23,5.7
                c-1.6-1.4-3.6-2.3-5.9-2.3c-1.5,0-2.9,0.4-4.1,1c-1.2-0.6-2.6-1-4.1-1c-4.9,0-8.9,4-8.9,9c0,4.6,3.5,8.4,7.9,8.9V24h-3
                c-0.5,0-1,0.4-1,1c0,0.6,0.4,1,1,1h3v3c0,0.6,0.4,1,1,1s1-0.4,1-1v-3h3c0.5,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-3v-2.7
                c1.1-0.1,2.1-0.5,3.1-0.9c1.2,0.6,2.6,1,4.1,1c4.9,0,8.9-4,8.9-9c0-2-0.6-3.8-1.7-5.2L28,3.4V7c0,0.6,0.4,1,1,1s1-0.4,1-1V1
                C30,0.9,30,0.7,29.9,0.6z M8.9,19.4c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c0.8,0,1.5,0.1,2.2,0.4c-1.8,1.6-2.9,4-2.9,6.6
                c0,2.6,1.1,5,2.9,6.6C10.4,19.3,9.7,19.4,8.9,19.4z M15.8,12.4c0,2.3-1.1,4.4-2.8,5.6c-1.7-1.3-2.8-3.3-2.8-5.6S11.3,8,13,6.7
                C14.7,8,15.8,10.1,15.8,12.4z M17.1,19.4c-0.8,0-1.5-0.1-2.2-0.4c1.8-1.6,2.9-4,2.9-6.6c0-2.6-1.1-5-2.9-6.6
                c0.7-0.2,1.4-0.4,2.2-0.4c3.8,0,6.9,3.1,6.9,7S20.9,19.4,17.1,19.4z"/>
        </g>
    </svg>

</template>

<script>
    export default {
        name: "UG_svg"
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/chapter/UG_svg.vue